import { CoreStore } from "Stores/RESTStore/CoreStore";
import { action, observable, makeObservable } from "mobx";
import { API_URL } from "General/APIEndpoints";
import { projectsDataStore } from "Stores";
import { API } from "General/API";

export class WebDAVStore extends CoreStore {
  isVisible = false;
  fileId: number = null;

  constructor() {
    super();

    makeObservable(this, {
      isVisible: observable,
      fileId: observable,
      clear: action,
      fetch: action.bound,
      openFile: action.bound,
      hideModal: action.bound,
    });
  }

  url(fileId: number) {
    return API_URL.VIEWER.getWebDavLink(projectsDataStore.projectId, fileId);
  }

  clear() {
    this.isVisible = false;
    this.fileId = undefined;
  }

  async fetch() {
    try {
      const response: API_StringData = await API.getData(this.url(this.fileId));
      return response.stringValue;
    } catch (error) {
      throw error;
    }
  }

  openFile(fileId: number) {
    this.isVisible = true;
    this.fileId = fileId;
  }

  hideModal() {
    this.clear();
  }
}

export const webDavStore = new WebDAVStore();
